export default __webpack_public_path__ + "assets/d196af5d9a32adb349c877bbd2f21f1a.jpg";